var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcbc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.106 49.1642V36.9231H37.1892V49.2308V61.5385V73.8462H49.4969H61.6715V86.1539H49.4304H37.1227V98.4615V110.769V121.414V123.01H77.0395V110.703H49.4304V98.395H73.9792V96.7318V86.0873V73.7796V61.4719H61.605H49.4304V49.1642H77.106ZM0 79.9667C0 35.7921 35.7921 0 80.0333 0C124.208 0 160.067 35.7921 160.067 79.9667C160.067 124.141 124.274 159.933 80.0333 159.933C35.7921 160 0 124.208 0 79.9667ZM12.3742 79.9667C12.3742 42.6445 42.6445 12.3742 79.9667 12.3742C117.289 12.3742 147.559 42.6445 147.559 79.9667C147.559 117.289 117.289 147.559 79.9667 147.559C42.6445 147.626 12.3742 117.289 12.3742 79.9667ZM83.2931 110.703V123.01H123.143V110.703V98.395V86.0873H110.836H98.5946V73.8462H110.836H123.143V61.5385V49.2308V38.5198V36.9231H83.2931V49.2308H110.836V61.5385H86.2869V63.1351V73.8462V86.1539V98.4615H98.7276H110.836V110.769H83.2931V110.703Z",
    fill: "#B2292E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.106 49.1642V36.9231H37.1892V49.2308V61.5385V73.8462H49.4969H61.6715V86.1539H49.4304H37.1227V98.4615V110.769V121.414V123.01H77.0395V110.703H49.4304V98.395H73.9792V96.7318V86.0873V73.7796V61.4719H61.605H49.4304V49.1642H77.106ZM0 79.9667C0 35.7921 35.7921 0 80.0333 0C124.208 0 160.067 35.7921 160.067 79.9667C160.067 124.141 124.274 159.933 80.0333 159.933C35.7921 160 0 124.208 0 79.9667ZM12.3742 79.9667C12.3742 42.6445 42.6445 12.3742 79.9667 12.3742C117.289 12.3742 147.559 42.6445 147.559 79.9667C147.559 117.289 117.289 147.559 79.9667 147.559C42.6445 147.626 12.3742 117.289 12.3742 79.9667ZM83.2931 110.703V123.01H123.143V110.703V98.395V86.0873H110.836H98.5946V73.8462H110.836H123.143V61.5385V49.2308V38.5198V36.9231H83.2931V49.2308H110.836V61.5385H86.2869V63.1351V73.8462V86.1539V98.4615H98.7276H110.836V110.769H83.2931V110.703Z",
    stroke: "#B2292E",
    strokeWidth: 0.02
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcbc);
export default __webpack_public_path__ + "static/media/icbc.765147af.svg";
export { ForwardRef as ReactComponent };